'use strict';
(function () {
  angular.module('pentaApp').factory('privateFiles.resource', service);

  service.$inject = ['resourceHelper.factory'];
  function service(resourceHelper) {
    return resourceHelper.defaultResource('/progressiveApp/api/privateFiles', null, {});
  }

})();